
const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const backendDomain = process.env.NODE_ENV === 'development'
    ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
    : process.env.NODE_ENV === 'production'
        // ? "https://naach-boutique.onrender.com"   // Use the production API in production environment
        ? "https://kl-property-live.onrender.com"
        : "http://192.168.0.1:5000";

//cSpell: ignore deactive

const SummaryApi = {
    // ===================== AUTH ROUTES=====================
    verifyOtp: {
        url: `${backendDomain}/api/auth/verify-otp`,
        method: "post"
    },
    signIn: {
        url: `${backendDomain}/api/auth/login`,
        method: "post"
    },
    forgotPassword: {
        url: `${backendDomain}/api/auth/forgot-password`,
        method: "POST"
    },
    resetPassword: {
        url: `${backendDomain}/api/auth/reset-password`,
        method: "post"
    },

    // ===================== USERS / CUSTOMERS ROUTES =====================
    getProfile: {
        url: `${backendDomain}/api/auth/view-one`,
        method: "get"
    },
    updateProfile: {
        url: `${backendDomain}/api/user/update-profile`,
        method: "put"
    },
    // ===================== ENQUIRY ROUTES =====================
    createEnquiry: {
        url: `${backendDomain}/api/enquiries/create`,
        method: "post"
    },
    getAllEnquiries: {
        url: `${backendDomain}/api/enquiries/view-all`,
        method: "get"
    },
    getOneEnquiry: {
        url: (enquiryId) => `${backendDomain}/api/enquiries/view-one/${enquiryId}`,
        method: "get"
    },
    updateStatusEnquiry: {
        url: (enquiryId) => `${backendDomain}/api/enquiries/status-update/${enquiryId}`,
        method: "patch"
    },
    deleteEnquiry: {
        url: (enquiryId) => `${backendDomain}/api/enquiries/delete-one/${enquiryId}`,
        method: "delete"
    },

    // ===================== PROPERTY ROUTES =====================
    createProperty: {
        url: `${backendDomain}/api/property/create`,
        method: "post"
    },
    getAllProperties: {
        url: `${backendDomain}/api/property/view-all`,
        method: "get"
    },
    getOneProperty: {
        url: (propertyId) => `${backendDomain}/api/property/view-one/${propertyId}`,
        method: "get"
    },
    updateOneProperty: {
        url: (propertyId) => `${backendDomain}/api/property/update-one/${propertyId}`,
        method: "put"
    },
    deleteOneProperty: {
        url: (propertyId) => `${backendDomain}/api/property/delete-one/${propertyId}`,
        method: "delete"
    },
    homeCategoryPreview: {
        url: `${backendDomain}/api/property/category-preview`,
        method: "get"
    },

    // ===================== BANNERS ROUTES =====================

    getAllBanners: {
        url: `${backendDomain}/api/banners/view-all`,
        method: "get"
    },
    updateBanner: {
        url: (id) => `${backendDomain}/api/banners/update/${id}`,
        method: "put"
    },
    createBanner: {
        url: `${backendDomain}/api/banners/upload`,
        method: "post",
    },

    deleteBanner: {
        url: (id) => `${backendDomain}/api/banners/delete/${id}`,
        method: "delete"
    },

    // ===================== TESTIMONIALS ROUTES =====================
    getAllTestimonials: {
        url: `${backendDomain}/api/testimonial/view-all`,
        method: "get"
    },

    createTestimonial: {
        url: `${backendDomain}/api/testimonial/create`,
        method: "post"
    },

    getOneTestimonial: {
        url: (id) => `${backendDomain}/api/testimonial/view/${id}`,
        method: "get"
    },

    updateOneTestimonial: {
        url: (id) => `${backendDomain}/api/testimonial/update/${id}`,
        method: "put"
    },

    deleteOneTestimonial: {
        url: (id) => `${backendDomain}/api/testimonial/delete/${id}`,
        method: "delete"
    },



    // ===================== GALLERY ROUTES =====================
    createGallery: {
        url: `${backendDomain}/api/media/create`,
        method: "post"
    },
    getAllGallery: {
        url: `${backendDomain}/api/media/view-all`,
        method: "get"
    },
    updateOneGallery: {
        url: (id) => `${backendDomain}/api/media/update/${id}`,
        method: "put"
    },
    deleteOneGallery: {
        url: (id) => `${backendDomain}/api/media/delete/${id}`,
        method: "delete"
    },


};

export default SummaryApi;